module.exports = __webpack_public_path__ + "img/27.d3b7dcce.png";